import React, { Suspense, lazy } from 'react';
import { Tabs } from 'antd';
import { isEmpty as _isEmpty } from 'lodash-es';
import './GraasStoreGroupPicker.scss';
import { useTranslation } from 'react-i18next';

const StoresTab = lazy(() => import(/*webpackChunkName: 'StoresTab'*/ './StoresTab'));
const StoreGroups = lazy(() => import(/*webpackChunkName: 'StoresGroups'*/ './StoreGroupTab'));

const GraasStoreGroupPicker = props => {
  const {
    initialChannels,
    initialSourceChannels,
    selectedChannels,
    allChannels,
    onCancel,
    onApplyChanges,
    channelGroup,
    selectedChannelGroup,
    isChannelEnabledFlag,
    isInactiveChannelEnabled,
    isChannelCurrencyEnabled,
    isShowSourceCurrency,
    isShowGroupByChannel,
    disabledChannels,
    customDisabledMsg
  } = props;

  const { t } = useTranslation();

  const getActiveKey = () => {
    if (!_isEmpty(selectedChannelGroup)) return 'store_group';
    if (!_isEmpty(selectedChannels)) return 'stores';
    return 'stores';
  };

  const storesTabProps = {
    initialChannels,
    initialSourceChannels,
    selectedChannels,
    allChannels,
    onSelectChannels: onApplyChanges,
    onCancel,
    isChannelEnabledFlag,
    isChannelCurrencyEnabled,
    isInactiveChannelToggle: isInactiveChannelEnabled,
    isShowSourceCurrency: isShowSourceCurrency,
    isShowGroupByChannel,
    ...(disabledChannels && !_isEmpty(disabledChannels) && { disabledChannels }),
    ...(disabledChannels && !_isEmpty(disabledChannels) && { customDisabledMsg })
  };

  const storeGroupsTabProps = {
    initialChannels,
    channelGroupList: channelGroup || [],
    selectedChannelGroup,
    onSelectChannelGroup: onApplyChanges,
    onCancel,
    ...(disabledChannels && !_isEmpty(disabledChannels) && { disabledChannels })
  };

  return (
    <div className='c-tabs' style={{ width: 800 }} qa-data='GraasStoreGroupPicker'>
      <Tabs defaultActiveKey={getActiveKey()}>
        <Tabs.TabPane tab={t('GRAAS_CHANNELS_GRAAS')} key='stores'>
          <Suspense fallback={<></>}>
            <StoresTab {...storesTabProps} />
          </Suspense>
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('GRAAS_CHANNEL_GROUPS_GRAAS')} key='store_group'>
          <Suspense fallback={<></>}>
            <StoreGroups {...storeGroupsTabProps} />
          </Suspense>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default GraasStoreGroupPicker;
